
import {
    InitClient,
    GetByParas,
    Post,
    PostWithParas,
    PostNoParas,
  } from "../ZeusAPIClient.js";
  import { apiConfig } from "../../config.js";
  import { PagingBody } from "../Model/PagingBody";
  import { GetSingleSysItem } from "../Logic/SysItemLogic";
  import { GetCurrentUserInfo } from "../Logic/HomeLogic";
  import { GetFrameById, GetSingeleUser } from "../Logic/StructureLogic";
  import { Reflect } from "core-js";
  
InitClient(apiConfig.clientId, apiConfig.clientSecret, apiConfig.host);

/*
*  改接口获取产品类列表
*/

//获取我发起的的列表
async function GetUserCreateProductTasks(
    userid,
    searchText,
    flowid,
    pageIndex,
    pageSize
  ) {
    var data = {
      userid: userid,
      pageIndex: pageIndex,
      pageSize: pageSize,
      searchText: searchText,
      flowId: flowid,
    };
    return Post("442bf58d-9c4c-44fe-8e7b-f99adbf073ab", data);
  }

//获取待我审批的列表
async function GetProductWaitTasks(userid, searchText, flowid, pageIndex, pageSize) {
    var data = {
      userid: userid,
      searchText: searchText,
      flowId: flowid,
      pageIndex: pageIndex,
      pageSize: pageSize,
    };
    return Post("552bae82-ab95-49ae-86d8-159ecce12024", data);
}

//获取我处理的列表
async function GetProductUserDealTasks(
    userid,
    searchText,
    flowid,
    pageIndex,
    pageSize
  ) {
    var data = {
      userid: userid,
      pageIndex: pageIndex,
      pageSize: pageSize,
      searchText: searchText,
      flowId: flowid,
    };
    return Post("a1c3d186-c2d2-45e5-a81d-be7cf5bce287", data);
  }

//获取抄送我的列表
async function GetProductCCUserTasks(userid, searchText, flowid, pageIndex, pageSize) {
    var data = {
      userid: userid,
      pageIndex: pageIndex,
      pageSize: pageSize,
      searchText: searchText,
      flowId: flowid,
    };
    return Post("230b9620-30ae-412d-9b6f-d883cfe53b9b", data);
}

//获取所有流程
async function GetProductWorkFlow() {
    var paras = {};
    return GetByParas("6aa06871-a2bf-4033-9ab4-b24617b974d9", paras);
  }

export {
    GetUserCreateProductTasks,
    GetProductWaitTasks,
    GetProductUserDealTasks,
    GetProductCCUserTasks,
    GetProductWorkFlow
}